<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header">
        <v-menu offset-y>
          <v-btn color="primary" slot="activator">{{ $t('Ejercicio') }}: {{ year }}</v-btn>
          <v-list>
            <v-list-tile v-for="y in years" :key="y" @click="year = y">
              <v-list-tile-title>{{ y }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
      <template slot="footer-row">
        <fiscal-obligations-upload :year="year"></fiscal-obligations-upload>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import FiscalObligationsUpload from '../components/fiscal-obligations/FiscalObligationsUpload.vue';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    FiscalObligationsUpload,
  },

  data: () => ({
    year: 2024,
    years: [2020, 2021, 2022, 2023, 2024],
  }),
  mounted() {
    this.setInitialYear();
  },
  methods: {
    setInitialYear() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      this.year = year;
    },
  },
};
</script>
